import * as React from "react";
import { forwardRef } from "react";
const SvgStraight = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 23, height: 23, viewBox: "0 0 123 114", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("line", { x1: 2.63695, y1: 111.418, x2: 120.637, y2: 3.41815, stroke: "black", strokeWidth: 7 }));
const ForwardRef = forwardRef(SvgStraight);
export default ForwardRef;
